import { render, staticRenderFns } from "./BlogDetailV.vue?vue&type=template&id=2019a30a&scoped=true"
import script from "./BlogDetailV.vue?vue&type=script&lang=js"
export * from "./BlogDetailV.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailV.vue?vue&type=style&index=0&id=2019a30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2019a30a",
  null
  
)

export default component.exports